import styled from "styled-components";

export const StepsWrapper = styled.div`
width: 100%;
background: transparent radial-gradient(closest-side at 50% 0%, #0A1F62 0%, #061648 100%, #061648 100%) 0% 0% no-repeat padding-box;
border-radius: 0px 0px 0px 0px;
display: flex;
flex-direction: row;
padding-top: 50px;
padding-bottom: 50px;
min-height: 400px;
`

export const StepsContent = styled.div`
display: flex;
flex-direction: column;
padding-top: 50px;
padding-bottom: 50px;
`

export const StepsHeader = styled.div`
font-size: 48px;
font-weight: 900;
letter-spacing: -0.25px;
color: #FFF;
padding: 20px;
margin: auto;
text-align: center;
width: 100%;
`
export const StepsHeaderSubtitle = styled.p`
text-align: center;
letter-spacing: 2px;
color: #748394;
opacity: 1;
padding: 20px;
margin: auto;
width: 100%;
`
export const P20 = styled.div`
padding: 20px;
`

export const RoundNumber = styled.div`
border: 1px solid #30D1FF;
border-radius: 50%;
color: #30D1FF;
margin-left: 0;
text-align: center;
width: 50px;
height: 50px;
display: flex;
justify-content: center;
align-items: center;
margin-bottom: 20px;
`

export const StepInfo = styled.div`
letter-spacing: -0.11px;
color: #FFFFFF;
font-size: 14px;
font-weight: 900;
`
export const StyledImg = styled.img`
width: 100%;
`